// Polyfill
import '@babel/polyfill'

import '../assets'

import Vue from 'vue'
import Vuex from 'vuex'
import VueBootstrapper from 'vue-bootstrapper'
import Vuelidate from 'vuelidate'

import FormView from '@components/form_view'
import ExpiredView from '@components/expired_view'
import FullscreenModal from '@components/fullscreen_modal'
import SaveDraftContent from '@components/save-draft-content'

import EventBus from './event_bus';

import ModalMixins from '@mixins/modal_mixins'

import store from '@store'

// Vue.use(VueBootstrapper, { store })
Vue.use(Vuelidate)

const vueInstance = new Vue({
  el: '#form-root',
  store,
  mixins: [
    ModalMixins
  ],
  data () {
    return {
      modalComponent: null,
      modalComponentProps: null
      // windowWidth: 0,
      // windowHeight: 0,
      // routes: [],
    }
  },
  components:{
    FormView,
    ExpiredView,
    SaveDraftContent,
    FullscreenModal
  },
  created () {
  },
  props: {
  },
  mounted () {
    EventBus.$on('save-draft-modal', this.onSaveDraftModalEmit)
  },
  methods: {
    onModalHide(){
      this.modalComponent = null;
      this.modalComponentProps = null;
    }
  },
})
